<template>
  <div
    class="campaign-statistics"
    :class="isDarkMode ? 'dark' : ''"
  >
    <div class="campaign-statistics--blocks row d-flex">
      <div
        class="col-md-6 col-sm-6 col-xs-12 mb-3 col-lg-4 col-xl-4"
        style="height: 185px"
      >
        <b-card
          class="animation-card"
          title="Total Subscribers"
          @click="navigateToSubscribers()"
        >
          <p
            class="campaign-statistics--count"
            :class="isDarkMode ? 'count-dark' : ''"
          >
            {{ formatNumber(statsCount.totalSubscribers) }}
          </p>
          <div class="campaign-statistics--footer">
            <div class="d-flex flex-column">
              <div class="d-flex align-items-center justify-content-between">
                <span class="d-block pl-1" style="font-size: 13px; font-weight: 400">Verified</span>
                <span class="fs-2" style="font-weight: 600">
                  {{
                    statsCount.totalVerifiedSubscribers
                      ? formatNumber(statsCount.totalVerifiedSubscribers)
                      : 0
                  }}
                </span>
              </div>
              <div class="d-flex align-items-center justify-content-between">
                <span class="d-block pl-1" style="font-size: 13px; font-weight: 400">Pending</span>
                <span class="fs-2" style="font-weight: 600">
                  {{
                    statsCount.totalPendingSubscribers
                      ? formatNumber(statsCount.totalPendingSubscribers)
                      : 0
                  }}
                </span>
              </div>
              <div class="d-flex align-items-center justify-content-between">
                <span class="d-block pl-1" style="font-size: 13px; font-weight: 400">Opt Out</span>
                <span class="fs-2" style="font-weight: 600">
                  {{
                    statsCount.totalOptOutSubscribers
                      ? formatNumber(statsCount.totalOptOutSubscribers)
                      : 0
                  }}
                </span>
              </div>
            </div>
          </div>
        </b-card>
      </div>
      <div
        class="col-md-6 col-sm-6 col-xs-12 mb-3 col-lg-4 col-xl-4"
        style="height: 185px"
      >
        <b-card
          class="animation-card"
          title="Campaign Events"
          @click="navigateToEvents()"
        >
          <p
            class="campaign-statistics--count"
            :class="isDarkMode ? 'count-dark' : ''"
          >
            {{ formatNumber(statsCount.totalEvents) }}
          </p>
        </b-card>
      </div>
      <div
        class="col-md-6 col-sm-6 col-xs-12 mb-3 col-lg-4 col-xl-4"
        style="height: 185px"
      >
        <b-card title="Messages">
          <p
            class="campaign-statistics--count"
            :class="isDarkMode ? 'count-dark' : ''"
          >
            {{
              statsCount.messages && statsCount.messages.totalCount
                ? statsCount.messages.totalCount
                : 0
            }}
          </p>

          <div class="campaign-statistics--footer">
            <div class="d-flex justify-content-between">
              <span class="d-block" style="font-weight: 400">Undelivered</span>
              <span style="font-weight: 600">
                {{
                  statsCount.undelivered && statsCount.undelivered.totalCount
                    ? statsCount.undelivered.totalCount
                    : 0
                }}
              </span>
            </div>
          </div>
        </b-card>
      </div>
      <div
        class="col-md-6 col-sm-6 col-xs-12 mb-3 col-lg-4 col-xl-4"
        style="height: 185px"
      >
        <b-card title="New Subscribers">
          <p
            class="campaign-statistics--count"
            :class="isDarkMode ? 'count-dark' : ''"
          >
            {{
              statsCount && statsCount.newSubscribers
                ? statsCount.newSubscribers.totalCount
                : 0
            }}
          </p>
          <div class="campaign-statistics--footer">
            <div id="noOfNewSubscribersChart"></div>
          </div>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import ApexCharts from "apexcharts";
import formatter from "@/mixins/formatter";

let noOfNewSubscribersChart = null;
export default {
  name: "CampaignStatistics",
  mixins: [formatter],
  props: {
    isDarkMode: Boolean,
    statsCount: Object,
  },
  data() {
    return {
      noOfNewSubscribersOptions: {
        chart: {
          height: 30,
          type: "area",
          sparkline: { enabled: true },
        },
        stroke: {
          curve: "smooth",
          width: 3,
        },
        tooltip: {
          theme: this.isDarkMode ? "dark" : "light",
        },
      },
      series: {
        noOfNewSubscribers: [],
      },
      noOfSubscriberMonths: [],
    };
  },
  computed: {
    currentCampaignId() {
      return this.$route.params.campaignId;
    }
  },
  watch: {
    isDarkMode(newVal, oldVal) {
      if (newVal !== oldVal) {
        noOfNewSubscribersChart.updateOptions({
          tooltip: {
            theme: newVal === true ? "dark" : "light",
          },
        });
      }
    },
    series(newVal, oldVal) {
      if (newVal !== oldVal) {
        noOfNewSubscribersChart.updateSeries(this.series.noOfNewSubscribers);
        noOfNewSubscribersChart.updateOptions(this.noOfNewSubscribersOptions);
      }
    },
    statsCount(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.getFormattedData();
      }
    },
  },
  mounted() {
    this.getFormattedData();
    this.renderChart();
  },
  methods: {
    getFormattedData() {
      const subscribersGraphData = [];
      const monthData = [];

      if (
        this.statsCount.newSubscribers &&
        this.statsCount.newSubscribers.graphData.length > 0
      ) {
        this.statsCount.newSubscribers.graphData.map((value) => {
          subscribersGraphData.push(value.count);
          monthData.push(value.x_axis);
        });
      }
      this.noOfSubscriberMonths = [...monthData];

      this.series = {
        noOfNewSubscribers: [
          {
            name: "New Subscribers",
            data:
              this.statsCount.newSubscribers &&
              this.statsCount.newSubscribers.graphData
                ? [...subscribersGraphData]
                : [],
            color: "#608bfa",
          },
        ],
      };
    },
    renderChart() {
      noOfNewSubscribersChart = new ApexCharts(
        document.querySelector("#noOfNewSubscribersChart"),
        {
          ...this.noOfNewSubscribersOptions,
          series: this.series.noOfNewSubscribers,
          xaxis: {
            categories: [...this.noOfSubscriberMonths],
          },
        }
      );
      noOfNewSubscribersChart.render();
    },
    navigateToEvents() {
      this.$router.push({ path: `/campaigns/${this.currentCampaignId}/events` }).catch(() => {});
    },
    navigateToSubscribers() {
      this.$router.push({ path: `/campaigns/${this.currentCampaignId}/subscribers` }).catch(() => {});
    },
  },
  beforeDestroy() {
    if (noOfNewSubscribersChart) {
      noOfNewSubscribersChart.destroy();
    }
  },
};
</script>


<style lang="scss">
.campaign-statistics {
  &--blocks {
    &.row {
      margin: 0 -0.5rem !important;
      > * {
        padding: 0 0.5rem !important;
      }
    }
  }
  & .card {
    height: 100%;
    box-shadow: 0 4px 8px 0 rgb(0 0 0 / 0%), 0 6px 20px 0 rgb(0 0 0 / 12%);
    border-radius: 1rem;
    &.animation-card {
      cursor: pointer;
      transition: transform 150 ease-in-out;

      &:hover {
        transform: scale(1.05);
      }
    }
  }
  & .card-title {
    font-size: 0.875rem;
    text-align: left;
    color: rgba(0, 0, 0, 0.7);
    font-weight: 500;
  }
  &--count {
    position: absolute;
    text-align: left;
    font-size: 1.6rem;
    font-weight: 700;
    margin-bottom: 0;
    top: 36%;
    color: rgba(0, 0, 0, 1);
  }
  & .count-dark {
    color: #b2b9bf !important;
  }
  &--footer {
    position: absolute;
    bottom: 15px;
    width: 100%;
    left: 0;
    padding: 0 16px;
  }
}
.campaign-statistics.dark {
  & .card-title {
    color: #b2b9bf !important;
  }
}
</style>